import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { LocalizationHelper } from './assets/ts/localizationHelper';

import faIR_Resources from './Locales/fa-IR';
import enGB_Resources from './Locales/en-GB';
import frCA_Resources from './Locales/fr-CA';

var resources = payload.LanguageResources;

var faIR = Object.assign(faIR_Resources, resources);
var enGB = Object.assign(enGB_Resources, resources);
var frCA = Object.assign(frCA_Resources, resources);

Vue.use(VueI18n);

// init i18n
export const i18n = new VueI18n({
    locale: payload.currentLocale.Culture,
    messages: {
        "fa-IR": faIR,
        "en-GB": enGB,
        "en-US": enGB,
        "en-CA": enGB,
        "fr-CA": frCA
    }
});

global.i18n = new LocalizationHelper(i18n);
global.vueI18n = i18n;
